webpackJsonp([114276838955818,60335399758886],{

/***/ 370:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(604);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(370);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 1809:
/***/ (function(module, exports, __webpack_require__) {

	!function(e,o){ true?module.exports=o():"function"==typeof define&&define.amd?define(o):(e.ReactIntlLocaleData=e.ReactIntlLocaleData||{},e.ReactIntlLocaleData.it=o())}(this,function(){"use strict";return[{locale:"it",pluralRuleFunction:function(e,o){var t=!String(e).split(".")[1];return o?11==e||8==e||80==e||800==e?"many":"other":1==e&&t?"one":"other"},fields:{year:{displayName:"anno",relative:{0:"quest’anno",1:"anno prossimo","-1":"anno scorso"},relativeTime:{future:{one:"tra {0} anno",other:"tra {0} anni"},past:{one:"{0} anno fa",other:"{0} anni fa"}}},month:{displayName:"mese",relative:{0:"questo mese",1:"mese prossimo","-1":"mese scorso"},relativeTime:{future:{one:"tra {0} mese",other:"tra {0} mesi"},past:{one:"{0} mese fa",other:"{0} mesi fa"}}},day:{displayName:"giorno",relative:{0:"oggi",1:"domani",2:"dopodomani","-2":"l’altro ieri","-1":"ieri"},relativeTime:{future:{one:"tra {0} giorno",other:"tra {0} giorni"},past:{one:"{0} giorno fa",other:"{0} giorni fa"}}},hour:{displayName:"ora",relative:{0:"quest’ora"},relativeTime:{future:{one:"tra {0} ora",other:"tra {0} ore"},past:{one:"{0} ora fa",other:"{0} ore fa"}}},minute:{displayName:"minuto",relative:{0:"questo minuto"},relativeTime:{future:{one:"tra {0} minuto",other:"tra {0} minuti"},past:{one:"{0} minuto fa",other:"{0} minuti fa"}}},second:{displayName:"secondo",relative:{0:"ora"},relativeTime:{future:{one:"tra {0} secondo",other:"tra {0} secondi"},past:{one:"{0} secondo fa",other:"{0} secondi fa"}}}}},{locale:"it-CH",parentLocale:"it"},{locale:"it-SM",parentLocale:"it"},{locale:"it-VA",parentLocale:"it"}]});


/***/ }),

/***/ 891:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 604:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(4);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(5);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(569);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactIntl = __webpack_require__(20);
	
	var _it = __webpack_require__(1809);
	
	var _it2 = _interopRequireDefault(_it);
	
	__webpack_require__(1716);
	
	__webpack_require__(891);
	
	var _Alert = __webpack_require__(111);
	
	var _it3 = __webpack_require__(305);
	
	var _it4 = _interopRequireDefault(_it3);
	
	var _en = __webpack_require__(304);
	
	var _en2 = _interopRequireDefault(_en);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	(0, _reactIntl.addLocaleData)(_it2.default);
	
	var messages = {
	  it: _it4.default,
	  en: _en2.default
	};
	
	var TemplateWrapper = function (_React$Component) {
	  _inherits(TemplateWrapper, _React$Component);
	
	  function TemplateWrapper(props) {
	    _classCallCheck(this, TemplateWrapper);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      isScrollActive: false
	    };
	    return _this;
	  }
	
	  TemplateWrapper.prototype.getChildContext = function getChildContext() {
	    var _this2 = this;
	
	    return { toggleOverflow: function toggleOverflow(active) {
	        return _this2.toggleOverflow(active);
	      } };
	  };
	
	  TemplateWrapper.prototype.toggleOverflow = function toggleOverflow(active) {
	    this.setState({ isScrollActive: active });
	  };
	
	  TemplateWrapper.prototype.render = function render() {
	    var locale = this.props.location.pathname.startsWith('/it') ? 'it' : 'en';
	
	    return _react2.default.createElement(
	      _reactIntl.IntlProvider,
	      { locale: locale, messages: messages[locale] },
	      _react2.default.createElement(
	        _Alert.AlertProvider,
	        null,
	        _react2.default.createElement(
	          'div',
	          { className: this.state.isScrollActive ? 'intro__overflow' : '' },
	          _react2.default.createElement(_reactHelmet2.default, {
	            title: 'Kubikoff',
	            meta: [{ name: 'description', content: 'Sample' }, { name: 'keywords', content: 'sample, something' }, { name: 'google-site-verification', content: 'ckfyPbLUkts8Iw5MPg-uX02O5pa7dN1rXdlVF1uosgY' }]
	          }),
	          _react2.default.createElement('script', {
	            dangerouslySetInnerHTML: {
	              __html: '\n                (function (w,d) {\n                  var loader = function () {\n                    var s = d.createElement("script"),\n                    tag = d.getElementsByTagName("script")[0]; s.src="https://cdn.iubenda.com/iubenda.js";\n                    tag.parentNode.insertBefore(s,tag);\n                  };\n                  if(w.addEventListener){\n                    w.addEventListener("load", loader, false);\n                  }else if(w.attachEvent){\n                    w.attachEvent("onload", loader);\n                  }else{w.onload = loader;}\n                })(window, document)\n                '
	            }
	          }),
	          _react2.default.createElement(
	            'div',
	            null,
	            this.props.children()
	          )
	        )
	      )
	    );
	  };
	
	  return TemplateWrapper;
	}(_react2.default.Component);
	
	TemplateWrapper.propTypes = {
	  children: _propTypes2.default.func
	};
	
	TemplateWrapper.childContextTypes = {
	  toggleOverflow: _propTypes2.default.func
	};
	
	exports.default = TemplateWrapper;
	module.exports = exports['default'];

/***/ }),

/***/ 1716:
/***/ (function(module, exports) {

	// empty (null-loader)

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-31976a91e5dde00ee65c.js